import React, { forwardRef } from "react";
import {
  Dialog as MuiDialog,
  DialogTitle,
  IconButton,
  Grow,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const Transition = forwardRef(function Transition(props, ref) {
  return <Grow ref={ref} {...props} timeout={400} />;
});

/**
 * Three separate things decide how a dialog can be dismissed, and they used to be
 * welded together:
 *
 *   setShow    — hands the dialog a way to close itself. Without it nothing can
 *                dismiss the dialog except the content's own buttons.
 *   onClose    — whether a backdrop click / Esc is allowed to close it. Set it to
 *                false for anything shown once and not recoverable (a setup key).
 *   showClose  — whether the header X is DRAWN.
 *
 * `showClose` exists because a dialog whose content already ends in a Close or
 * Cancel button should not also carry an X in an otherwise empty header band: it
 * is a second exit for the same door, and the band it needs pushes the real title
 * down the screen. Pass `showClose={false}` there and keep backdrop close.
 */
export default function Dialog(props) {
  const {
    show,
    setShow,
    maxWidth = "sm",
    children,
    onClose = true,
    showClose = true,
    fullScreen = false,
    ...other
  } = props;

  const handleClose = () => {
    // Move focus to body to prevent focus issues
    document.activeElement?.blur();
    setShow !== undefined && onClose && setShow(false);
  };

  return (
    <MuiDialog
      disableEnforceFocus
      open={show}
      TransitionComponent={Transition}
      keepMounted
      fullScreen={fullScreen}
      onClose={handleClose}
      aria-describedby="dialog"
      PaperProps={{
        className: "bg-white !m-3 !md:m-6 w-full",
      }}
      maxWidth={maxWidth}
      {...other}
    >
      {setShow !== undefined && showClose && (
        <DialogTitle className="text-right p-10">
          <IconButton onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
      )}
      {children}
    </MuiDialog>
  );
}
